import { Component, OnInit, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { CardType, IndexService, defaultCardSize, UserIndexCard, IndexLayout } from '../index.service';
import { MatDialog, MatDialogRef } from '@angular/material';
interface SettingCard {
	Type: CardType;
	Name: string;
	Enabled: boolean;
}
@Component({
	selector: 'common-setting-dialog',
	templateUrl: './setting-dialog.component.html',
	styleUrls: ['./setting-dialog.component.scss']
})
export class SettingDialogComponent implements OnInit {
	@HostBinding('class.c-index-setting-dialog') hostClass = true;
	layout: IndexLayout;
	cards: SettingCard[] = [
		{
			Type: CardType.navigation,
			Name: 'å¿«éå¯¼èª',
			Enabled: false
		},
		{
			Type: CardType.calendar,
			Name: 'æ¥å',
			Enabled: false
		},
		{
			Type: CardType.notice,
			Name: 'å¸åæ ',
			Enabled: false
		},
		{
			Type: CardType.datalist,
			Name: 'æ°æ®è¡¨æ ¼',
			Enabled: false
		},
		{
			Type: CardType.chart,
			Name: 'åæå¾',
			Enabled: false
		}
	];
	constructor(
		public svr: IndexService,
		private elementRef: ElementRef,
		public dialogRef: MatDialogRef<SettingDialogComponent>
	) {}

	ngOnInit() {
		this.elementRef.nativeElement.parentElement.style = 'padding:0px;';
		this.layout = this.svr.userSetting.Layout;
		this.svr.userSetting.Cards.forEach(v => {
			const found = this.cards.find(c => c.Type === v.Type);
			if (found) {
				found.Enabled = true;
			}
		});
	}
	ok() {
		const arr = this.cards.filter(v => v.Enabled).map(v => {
			const found = this.svr.userSetting.Cards.find(c => c.Type === v.Type);
			if (found) {
				return found;
			}
			return {
				Type: v.Type,
				Size: defaultCardSize[v.Type],
				Setting: null
			} as UserIndexCard;
		});
		this.svr.userSetting.Cards = arr;
		this.svr.userSetting.Layout = this.layout;
		this.svr.updateSetting().subscribe();
		this.dialogRef.close(true);
	}
}
